import React from 'react';
import data from '../data';
import '../statement.css';

function Statement() {
  return (
    <div className="statement">
      <div dangerouslySetInnerHTML={{ __html: data.statement }} />
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <img src="/image/scaled/MdM_OrfordNess_studio.jpg" alt="Mahal de Man in the studio" style={{ width: '100%', height: 'auto' }} />
        <p style={{ fontSize: '14px', marginTop: '0.5rem' }}>Photo by j.b.e. mclean. Orford Ness 2025</p>
      </div>
    </div>
  );
}

export default Statement;